import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ArticleKindPicker } from '../../../../components/entity-picker/article-kind-picker/ArticleKindPicker';
import { FilterCard } from '../filter-card/FilterCard';

type Props = {
  title: string;
  value: { id: string; name: string }[] | null;
  onChange: (value: { id: string; name?: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const ArticleKindFilterCard: React.FC<Props> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    if (value.length === 1) return t(`ARTICLE_KIND.LONG.${value[0].id}`);
    return t('COMMON.CHOSEN', { count: value.length });
  }, [t, value]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <ArticleKindPicker
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
      />
    </FilterCard>
  );
};
